import React, {Component} from 'react'
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap'
import Form from 'react-jsonschema-form'
import {Mutation}from 'react-apollo'
import PropTypes from 'prop-types'
import {toast} from 'react-toastify'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import {generateMutation} from '../../../lib/graphql'

class Create extends Component{


    state = {
        loaded: false,
        MUTATION: ''
    }

    static getDerivedStateFromProps(props, state){
        const {schema, table, mutationType} = props.config
        const MUTATION = generateMutation(mutationType, table, schema)
        return {MUTATION, loaded: true}
    }

    render(){

        return (
            this.state.loaded && <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>
                <ModalBody>
                    <Mutation mutation={this.state.MUTATION}>
                        {(go) => (
                        <Form
                            {...this.props.config}
                            onSubmit={({formData}) => {
                                go({variables: formData})
                                    .then(res => {
                                        toast.success('Successfully Saved!', {autoClose: 2000})
                                        this.props.toggle()
                                    })
                                    .catch(e => toast(e.message, {autoClose: false}))
                            }}
                        >
                            <ModalFooter>
                                <Button
                                    size="sm"
                                    color="secondary"
                                    onClick={this.props.toggle}>
                                    <FontAwesomeIcon
                                        color="#fff"
                                        icon="times"/>{' '}
                                    Cancel
                                </Button>
                                <Button
                                    size="sm"
                                    color="success"
                                    type="submit">
                                    <FontAwesomeIcon
                                        color="#fff"
                                        icon="save"/>{' '}
                                    Save
                                </Button>
                            </ModalFooter>
                        </Form>)}
                    </Mutation>
                </ModalBody>

            </Modal>
        )
    }

}

Create.propTypes = {
    config: PropTypes.object
}

export default Create